export interface Props {
  className?: string;
}

const SvgComponent = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    viewBox="0 0 25 24"
    className={className}
  >
    <path strokeLinecap="round" strokeWidth={2} d="M9 5c1 2 4 5.5 7 7-4.5 2.5-6.38 5.924-7 7" />
  </svg>
);
export default SvgComponent;
